import React from 'react'

import HotelCard from './hotel-card'

const hotelBlockPattern = /<pre[^>]*>\s*<code[^>]*class="[^"]*language-hotel[^"]*"[^>]*>([\s\S]*?)<\/code>\s*<\/pre>/g

const decodeHtml = (value) =>
  value
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
    .replace(/&#([0-9]+);/g, (_, num) => String.fromCharCode(parseInt(num, 10)))

const parseHotel = (rawJson) => {
  try {
    return JSON.parse(decodeHtml(rawJson).trim())
  } catch (error) {
    return {
      name: 'ホテルブロックの読み込みエラー',
      comment: 'Contentful の hotel JSON ブロックの形式を確認してください。',
    }
  }
}

const ArticleBody = ({ html }) => {
  if (!html) return null

  const parts = []
  let lastIndex = 0
  let match

  while ((match = hotelBlockPattern.exec(html)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'html', value: html.slice(lastIndex, match.index) })
    }

    parts.push({ type: 'hotel', value: parseHotel(match[1]) })
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < html.length) {
    parts.push({ type: 'html', value: html.slice(lastIndex) })
  }

  return (
    <>
      {parts.map((part, index) => {
        if (part.type === 'hotel') {
          return <HotelCard key={'hotel-' + index} hotel={part.value} />
        }

        return (
          <div
            key={'html-' + index}
            dangerouslySetInnerHTML={{
              __html: part.value,
            }}
          />
        )
      })}
    </>
  )
}

export default ArticleBody
